import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useDemoMode } from '../context/DemoModeContext';

// Phase 1: this guard now has two responsibilities.
//
// 1. Per-admin demo mode (existing): when an admin has demo mode ON, only
//    farms in their `includedFarmIds` are reachable. Anything else redirects
//    to /dashboard.
//
// 2. Public demo farms (new): farms flagged `isPublicDemo: true` are always
//    reachable for any signed-in user, even when an admin has demo mode on.
//    This is what powers the freemium demo experience on DHT.
export default function DemoFarmRouteGuard({ children }) {
  const { farmId } = useParams();
  const { loading, isDemoModeEnabled, isFarmInDemoScope, isPublicDemoFarm } = useDemoMode();

  if (loading) return null;
  if (!farmId) return children;

  // Public demo farms are always accessible. Bypasses the admin-demo-scope check
  // so an admin running a demo can still reach the public demo property.
  if (isPublicDemoFarm(farmId)) return children;

  // Otherwise the existing admin-demo-mode scoping applies.
  if (!isDemoModeEnabled) return children;
  if (isFarmInDemoScope(farmId)) return children;

  return <Navigate to="/dashboard" replace />;
}
